import { format, parseISO } from "date-fns";
import { Box, Typography, Grid, Divider } from "@mui/material";
import _ from "lodash";
import logo from "assets/images/vivekanand.png";
import { normalizeHospitalDetails, pickHospitalLogo } from "utils/gst";
import { getInvoiceInsurerName, getInvoiceVisitDate } from "utils/invoiceBillingProvider";
import { useHospitalDetails } from "api/cutsom-hooks";

export default function ThermalContentHeader({ customerInfo, invoiceData, showGstDetails = true }) {
  
  const hospitalData = useHospitalDetails();

  if (!invoiceData) {
    return null;
  }

  const {
    invoice_number,
    created_at,
    payment_method,
  } = invoiceData;
  const hospitalDetails = normalizeHospitalDetails(hospitalData);
  const hospitalLogo = pickHospitalLogo(hospitalData, logo);
  const showGst = showGstDetails;
  const createdAtDate = new Date(created_at || new Date());
  const formattedDate = format(createdAtDate, "dd-MM-yyyy");
  const formattedTime = format(createdAtDate, "hh:mm a");
  const insurerName = getInvoiceInsurerName(invoiceData);
  const visitDate = getInvoiceVisitDate(invoiceData);
  return (
    <>
      <Box sx={{ textAlign: "center", mb: 1 }}>
        <Box
          component="img"
          src={hospitalLogo}
          alt="Hospital Logo"
          sx={{
            width: 70,
            height: 70,
            mx: "auto",
            display: "block",
            mb: 0.5,
          }}
        />
        <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
          {hospitalDetails.name}
        </Typography>
        {hospitalDetails.address && (
          <Typography sx={{ fontSize: "11px" }}>{hospitalDetails.address}</Typography>
        )}
        {showGst && hospitalDetails.gstNumber && (
          <>
            <Typography sx={{ fontSize: "11px" }}>GST: {hospitalDetails.gstNumber}</Typography>
            <Typography sx={{ fontSize: "11px" }}>PAN: {hospitalDetails.pan_number || "AAIAS8992G"}</Typography>
          </>
        )}
        <Divider sx={{ my: 0.5, borderColor: "black" }} />
      </Box>

      <Grid
        container
        spacing={0.25}
        sx={{
          maxWidth: "100%",
          "@media print": {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
          },
        }}
      >
        <Grid
          item
          xs={12}
          style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
        >
          <strong>Patient:</strong> {customerInfo.full_name} ({customerInfo.id})
        </Grid>
        {invoice_number && <Grid
          item
          xs={12}
          style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
        >
          <strong>Bill No:</strong> {invoice_number}
        </Grid>}
        {payment_method && (
          <Grid
            item
            xs={12}
            style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
          >
            <strong>Payment Method:</strong>{' '}
            {payment_method === 'hybrid' ? 'Cash + Online' : _.capitalize(payment_method)}
          </Grid>
        )}
        {insurerName && (
          <Grid
            item
            xs={12}
            style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
          >
            <strong>Insurance:</strong> {insurerName}
          </Grid>
        )}
        <Grid
          item
          xs={12}
          style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
        >
          <strong>Date:</strong> {formattedDate} {formattedTime}
        </Grid>
        {visitDate && (
          <Grid
            item
            xs={12}
            style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
          >
            <strong>Visit Date:</strong> {format(parseISO(visitDate), "dd-MM-yyyy")}
          </Grid>
        )}
        {(invoiceData?.receptionist) && (
            <Grid
              item
              xs={12}
              style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
            >
              <strong>Receptionist:</strong> {invoiceData?.receptionist?.full_name} (
              {invoiceData?.receptionist?.id})
            </Grid>
        )}
        {(() => {
          let doctorInfo = null;
          if (invoiceData?.other_details) {
            try {
              const additionalInfo = typeof invoiceData.other_details === 'string' 
                ? JSON.parse(invoiceData.other_details) 
                : invoiceData.other_details;
              if (additionalInfo?.doctor_id) {
                doctorInfo = invoiceData?.doctor || { 
                  id: additionalInfo.doctor_id, 
                  full_name: additionalInfo.doctor_name || 'N/A' 
                };
              }
            } catch (e) {
              console.error('Error parsing other_details:', e);
            }
          }
          if (invoiceData?.doctor && !doctorInfo) {
            doctorInfo = invoiceData.doctor;
          }
          return doctorInfo ? (
            <Grid
              item
              xs={12}
              style={{ fontSize: "12px", textAlign: "left", whiteSpace: "normal" }}
            >
              <strong>Doctor:</strong> {doctorInfo.full_name} ({doctorInfo.id})
            </Grid>
          ) : null;
        })()}
        {invoiceData?.store?.name && (
          <Grid
            item
            xs={12}
            style={{
              fontSize: "12px",
              textAlign: "left",
              whiteSpace: "normal",
            }}
          >
            <strong>Store:</strong> {invoiceData?.store?.name}
          </Grid>
        )}
        {invoiceData?.cancelledInvoiceIds && invoiceData.cancelledInvoiceIds.length > 0 && (
          <Grid
            item
            xs={12}
            style={{
              fontSize: "12px",
              textAlign: "left",
              whiteSpace: "normal",
            }}
          >
            <strong>Cancelled Invoices:</strong> {invoiceData.cancelledInvoiceIds.join(", ")}
          </Grid>
        )}
      </Grid>
      <Divider sx={{ my: 0.5, borderColor: "black" }} />
    </>
  );
}
